<template>
  <div class="priority-canvas">
    <div class="paiban-bread">
      <span class="material-list" @click="gotoMaterial">{{
        $t('main.sideBar.materialList')
      }}</span>
      <span>/</span>
      <span class="center-bread" @click="gotoPaiban">{{
        $t('main.sideBar.paibanResult')
      }}</span>
      <span>/</span>
      <span class="center-bread" @click="gotoSubtle">{{
        $t('arrangedPage.subtleArrange')
      }}</span>
      <span>/</span>
      <span class="final-bread">{{ $t('arrangedPage.editCutOrder') }}</span>
    </div>
    <div class="operation-tip">
      <span class="operation-tip-icon">
        <i class="iconfont icon-warning"></i>
      </span>
      <span>{{ $translateLang('使用快捷键 ctrl+z 撤销上一步操作') }}</span>
    </div>
    <div class="canvas-box">
      <canvas ref="priorityCanvas" @click="clickCanvas"></canvas>
    </div>
    <div class="operation-box">
      <div>
        <a-button @click="cancelChange" class="mr5">{{
          $t('common.cancel')
        }}</a-button>
        <a-button @click="resetChange" class="mr5">{{
          $t('common.reset')
        }}</a-button>
        <a-button @click="saveChange" class="confirm-btn">{{
          $t('common.confirm')
        }}</a-button>
      </div>
    </div>
  </div>
</template>

<script>
import { DrawPlankColorJs } from '@/data/plank'
import store from '@/store'
import { matchLayeredCutForPalnkThick } from '@/util/LayoutTool.js'
import { Plank } from '@/util/canvas/drawPlank'
import { plankDrawFactory } from '@/util/drawPlank'
import { getPathMinMaxPoint } from '@/util/plankCommonFuncs'
import { transformData } from '@/views/newPaiban/util/transformData'
import { mapState } from 'vuex'

// 默认缩放比例
const defaultScale = 5
// 大板和大板边框的默认偏移值
const defaultDeviation = 5
// 下刀顺序距边的默认距离
const defaultTextWidth = 3
// 下刀点距边的默认距离
const defaultDotWidth = 5
export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    bigpart: {
      type: [Object, Array],
    },
    trimSide: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      ctx: {},
      startTop: 100,
      startLeft: 0,
      scaleWidth: 0,
      scaleHeight: 0,
      plankWidth: 0,
      plankHeight: 0,
      priorityNum: 1,
      scalePercent: 1,
      /** 切割顺序弹窗内大板画布尺寸（不写回 props） */
      priorityCanvasWidth: 0,
      priorityCanvasHeight: 0,
      priorityHistory: [],
    }
  },
  computed: {
    ...mapState(['ncSetting']),
  },
  methods: {
    startDraw() {
      this.$nextTick(() => {
        let dom = this.$refs.priorityCanvas
        this.ctx = dom.getContext('2d')
        const [minX, minY, maxX, maxY] = getPathMinMaxPoint(this.bigpart.path)
        const width = maxX - minX
        const height = maxY - minY
        const recordHeight = (Number(height) / defaultScale) * this.scalePercent
        const recordWidth = (Number(width) / defaultScale) * this.scalePercent
        this.priorityCanvasWidth = recordWidth
        this.priorityCanvasHeight = recordHeight
        this.drawOneBigpart()
      })
    },
    gotoMaterial() {
      this.$router.push('/materialList')
    },
    gotoPaiban() {
      this.$emit('goBackPaiban')
      this.$emit('update:visible', false)
    },
    gotoSubtle() {
      this.cancelChange()
    },
    tranlateSizeFromScale(size) {
      return (size / defaultScale) * this.scalePercent
    },
    restoreScaleSize(scaleSize) {
      return (scaleSize / this.scalePercent) * defaultScale
    },
    drawOneBigpart() {
      let windowWidth = document.body.offsetWidth
      this.plankWidth = this.ncSetting.drawPlankWidth
      this.plankHeight = this.ncSetting.drawPlankheight
      this.startLeft = windowWidth / 2 - this.priorityCanvasWidth / 2
      let strokeColor = '#333'
      let strokeLine = 1
      let left = this.startLeft
      let top = this.startTop
      // 边框是比真正的大板要大一圈的圆角矩形, 而且顶部还有其他信息, 所以长宽多10, 起始点y要多30
      this.strokeRoundRect(
        this.ctx,
        left,
        top,
        this.priorityCanvasWidth + 2 * defaultDeviation,
        this.priorityCanvasHeight + 2 * defaultDeviation,
        5,
        strokeLine,
        strokeColor
      )
      this.ctx.fillStyle = '#ECECEC'
      this.ctx.beginPath()
      this.bigpart.path.forEach((point, idx) => {
        const x = left + defaultDeviation + this.tranlateSizeFromScale(point.x)
        const y = top + defaultDeviation + this.tranlateSizeFromScale(point.y)
        if (idx === 0) {
          this.ctx.moveTo(x, y)
        } else {
          this.ctx.lineTo(x, y)
        }
      })
      this.ctx.closePath()
      this.ctx.fill()
      // 绘制小板
      for (let i = 0; i < this.bigpart.parts.length; ++i) {
        let part = this.bigpart.parts[i]
        this.drawParts(
          this.ctx,
          part,
          left + defaultDeviation,
          top + defaultDeviation
        )
      }
    },

    /**
     * 绘制小板（与 drawPart 一致：Plank + plankDrawFactory）
     * @param { Object } part 小板数据
     * @param { Number } bigPankStartX 大板的绘制起始横坐标
     * @param { Number } bigPankStartY 大板的绘制起始纵坐标
     */
    drawParts(ctx, part, bigPankStartX, bigPankStartY) {
      const partTemp = transformData(part, store)
      const startX =
        bigPankStartX + (partTemp.startX / defaultScale) * this.scalePercent
      const startY =
        bigPankStartY + (partTemp.startY / defaultScale) * this.scalePercent

      const plank = new Plank(
        ctx,
        partTemp,
        startX,
        startY,
        defaultScale,
        this.scalePercent,
        { plankLineWidth: 1 }
      )

      if (partTemp.plankMerge) {
        plank.setFillStyle(DrawPlankColorJs.plankMerge)
      }

      const notDraw = ['cutOrder', 'plankSize', 'markModifiedSmallBoards']

      const draws = plankDrawFactory(
        ctx,
        partTemp,
        startX,
        startY,
        defaultScale,
        this.scalePercent,
        {
          dotWidth: defaultDotWidth * this.scalePercent,
          textWidth: defaultTextWidth * this.scalePercent,
          fontSize: 14,
        },
        notDraw
      )

      const isMatched = matchLayeredCutForPalnkThick({
        matCode: this.bigpart.matCode,
        thick: this.bigpart.thick,
        is_high_gloss_plank: this.bigpart.highlight === '非高光' ? false : true,
      })
      if (
        partTemp.curve_layered_cutting &&
        Number(partTemp.curve_layered_cutting_deep) < partTemp.thick &&
        !isMatched
      ) {
        plank.setStrokeStyle('skyblue')
        plank.setLineWidth(3)
      }

      plank.addStrategy(Object.keys(draws).map((it) => draws[it]))
      plank.draw()

      const rect = {
        x: startX,
        y: startY,
        width: (partTemp.rect.width / defaultScale) * this.scalePercent,
        height: (partTemp.rect.height / defaultScale) * this.scalePercent,
      }
      this.drawCutOrder(ctx, part, rect)
    },

    /**
     * 绘制临时切割顺序（showPriority），工厂 DrawCutOrder 使用 priority，此处单独绘制
     * @param { Object } part 小板数据
     * @param { Object } rect 小板的绘制属性
     */
    drawCutOrder(ctx, part, rect) {
      if (part.showPriority) {
        ctx.fillStyle = '#f00'
        let fontSize = 18
        ctx.font = `bold ${fontSize}px 'PingFangSC-Regular, PingFang SC'`
        // 文字的绘制, 是以起始点开始, 向上绘制(不知道为什么这个是反的)
        let text = {
          x: rect.x + defaultTextWidth,
          y: rect.y + defaultTextWidth + fontSize,
        }
        ctx.fillText(part.showPriority, text.x, text.y)
      }
    },

    /**
     * 该方法用来绘制一个有填充色的圆角矩形
     * @param cxt:canvas的上下文环境
     * @param x:左上角x轴坐标
     * @param y:左上角y轴坐标
     * @param width:矩形的宽度
     * @param height:矩形的高度
     * @param radius:圆的半径
     * @param fillColor:填充颜色
     **/
    fillRoundRect(cxt, x, y, width, height, radius, /*optional*/ fillColor) {
      //圆的直径必然要小于矩形的宽高
      if (2 * radius > width || 2 * radius > height) {
        return false
      }

      cxt.save()
      cxt.translate(x, y)
      //绘制圆角矩形的各个边
      this.drawRoundRectPath(cxt, width, height, radius)
      cxt.fillStyle = fillColor || '#000' //若是给定了值就用给定的值否则给予默认值
      cxt.fill()
      cxt.restore()
    },

    /**
     * 该方法用来绘制圆角矩形
     * @param cxt:canvas的上下文环境
     * @param x:左上角x轴坐标
     * @param y:左上角y轴坐标
     * @param width:矩形的宽度
     * @param height:矩形的高度
     * @param radius:圆的半径
     * @param lineWidth:线条粗细
     * @param strokeColor:线条颜色
     **/
    strokeRoundRect(
      cxt,
      x,
      y,
      width,
      height,
      radius,
      /*optional*/ lineWidth,
      /*optional*/ strokeColor
    ) {
      //圆的直径必然要小于矩形的宽高
      if (2 * radius > width || 2 * radius > height) {
        return false
      }

      cxt.save()
      cxt.translate(x, y)
      //绘制圆角矩形的各个边
      this.drawRoundRectPath(cxt, width, height, radius)
      cxt.lineWidth = lineWidth || 1 //若是给定了值就用给定的值否则给予默认值2
      cxt.strokeStyle = strokeColor || '#000'
      cxt.stroke()
      cxt.restore()
    },

    drawRoundRectPath(cxt, width, height, radius) {
      cxt.beginPath(0)
      //从右下角顺时针绘制，弧度从0到1/2PI
      cxt.arc(width - radius, height - radius, radius, 0, Math.PI / 2)
      //矩形下边线
      cxt.lineTo(radius, height)
      //左下角圆弧，弧度从1/2PI到PI
      cxt.arc(radius, height - radius, radius, Math.PI / 2, Math.PI)
      //矩形左边线
      cxt.lineTo(0, radius)
      //左上角圆弧，弧度从PI到3/2PI
      cxt.arc(radius, radius, radius, Math.PI, (Math.PI * 3) / 2)
      //上边线
      cxt.lineTo(width - radius, 0)
      //右上角圆弧
      cxt.arc(width - radius, radius, radius, (Math.PI * 3) / 2, Math.PI * 2)
      //右边线
      cxt.lineTo(width, height - radius)
      cxt.closePath()
    },

    clickCanvas(e) {
      let mousePoint = {
        x: e.offsetX,
        y: e.offsetY,
      }
      // 如果找到了, 则判断点击的位置
      if (
        mousePoint.x <=
          this.startLeft + this.priorityCanvasWidth + 2 * defaultDeviation &&
        mousePoint.y <=
          this.startTop + this.priorityCanvasHeight + 2 * defaultDeviation
      ) {
        // 判断点击的是否为大板, 还是顶部信息
        if (
          mousePoint.y >= this.startTop + defaultDeviation &&
          mousePoint.x >= this.startLeft + defaultDeviation
        ) {
          for (let i = 0; i < this.bigpart.parts.length; ++i) {
            let part = this.bigpart.parts[i]
            let rect = {
              x:
                this.startLeft +
                defaultDeviation +
                this.tranlateSizeFromScale(part.startX),
              y:
                this.startTop +
                defaultDeviation +
                this.tranlateSizeFromScale(part.startY),
            }
            let newPos = {
              x: this.restoreScaleSize(mousePoint.x - rect.x),
              y: this.restoreScaleSize(mousePoint.y - rect.y),
            }
            let curvePath = []
            if (part.path) {
              const curveHolesArr = part.curveHoles
                ?.map((it) => it.path)
                .filter(Boolean)
              curvePath = [...part.path]
              if (curveHolesArr?.length && curveHolesArr[0]) {
                curvePath.push(...curveHolesArr)
              }
            } else {
              curvePath = [
                [
                  { x: 0, y: 0 },
                  { x: part.rect.width, y: 0 },
                  { x: part.rect.width, y: part.rect.height },
                  { x: 0, y: part.rect.height },
                ],
              ]
            }
            let isInpoly = curvePath
              .map((curve) => this.isInPolygon(newPos, curve))
              .filter((e) => e)
            if (isInpoly.length == 1) {
              if (!part.hasOwnProperty('showPriority')) {
                this.assignPartPriority(part)
              }
            }
          }
        }
      }
    },

    // 判断点是否在多边形内部
    isInPolygon(checkPoint, polygonPoints) {
      let counter = 0
      let xinters
      let p1, p2
      let pointCount = polygonPoints.length
      p1 = polygonPoints[0]

      for (let i = 1; i <= pointCount; i++) {
        p2 = polygonPoints[i % pointCount]
        if (
          checkPoint.x > Math.min(p1.x, p2.x) &&
          checkPoint.x <= Math.max(p1.x, p2.x)
        ) {
          if (checkPoint.y <= Math.max(p1.y, p2.y)) {
            if (p1.x != p2.x) {
              xinters =
                ((checkPoint.x - p1.x) * (p2.y - p1.y)) / (p2.x - p1.x) + p1.y
              if (p1.y == p2.y || checkPoint.y <= xinters) {
                counter++
              }
            }
          }
        }
        p1 = p2
      }
      if (counter % 2 === 0) {
        return false
      } else {
        return true
      }
    },

    renderAll() {
      this.ctx.clearRect(0, 0, 1392, 744)
      this.drawOneBigpart()
    },

    assignPartPriority(part) {
      if (part.hasOwnProperty('showPriority')) {
        return
      }
      const num = this.priorityNum
      this.priorityHistory.push({
        index: part.index,
        plankID: part.plankID,
        partUniqueId: part.partUniqueId,
        num,
      })
      this.$emit('changeBigPartPriotity', part, num)
      this.priorityNum++
      this.renderAll()
    },

    undoLastPriorityChange() {
      const last = this.priorityHistory.pop()
      if (!last) {
        return
      }
      for (let i = 0; i < this.bigpart.parts.length; ++i) {
        const part = this.bigpart.parts[i]
        if (
          part.index == last.index &&
          part.plankID == last.plankID &&
          part.partUniqueId == last.partUniqueId
        ) {
          if (part.showPriority) {
            delete part.showPriority
          }
          break
        }
      }
      this.priorityNum = last.num
      this.renderAll()
    },

    handleKeydown(e) {
      const isUndo =
        (e.ctrlKey || e.metaKey) && e.key.toLowerCase() === 'z' && !e.shiftKey
      if (!isUndo) {
        return
      }
      e.preventDefault()
      this.undoLastPriorityChange()
    },

    cancelChange() {
      this.$emit('resetPriorityChange')
      this.$emit('update:visible', false)
    },
    resetChange() {
      this.$emit('resetPriorityChange')
      this.priorityNum = 1
      this.priorityHistory = []
      this.renderAll()
    },
    saveChange() {
      let flag = true
      for (let i = 0; i < this.bigpart.parts.length; ++i) {
        if (!this.bigpart.parts[i].hasOwnProperty('showPriority')) {
          flag = false
          break
        }
      }
      if (!flag) {
        this.$message({
          message: '请对所有板件设置切割顺序之后再进行此操作!',
          type: 'error',
        })
        return
      }
      this.$emit('updatePriority')
    },
  },
  mounted() {
    this.startDraw()
    const box = document.querySelector('.priority-canvas')
    // 更新canvas宽度
    this.$refs['priorityCanvas'].width = box.offsetWidth - 48
    this.$refs['priorityCanvas'].height = box.offsetHeight
    document.addEventListener('keydown', this.handleKeydown)
  },
  beforeDestroy() {
    document.removeEventListener('keydown', this.handleKeydown)
  },
}
</script>

<style scoped lang="less">
.priority-canvas {
  position: absolute;
  top: 0px;
  left: 0;
  z-index: 2;
  width: 100%;
  height: 100%;
  padding: 24px;
  background: #eee;
  .paiban-bread,
  .operation-tip {
    position: absolute;
    top: 0;
    left: 24px;
    width: 100%;
    height: 38px;
    padding: 0 24px;
    color: #333;
    font-size: 14px;
    line-height: 38px;
    background: #fafafa;
    cursor: pointer;
    .final-bread {
      color: #999;
      cursor: default;
    }
  }

  .operation-tip {
    top: 38px;
    color: #999;
  }
  .canvas-box {
    height: 100%;
    background: #fff;
  }
  .operation-box {
    position: absolute;
    bottom: 0;
    left: 0;
    z-index: 2;
    width: 100%;
    height: 76px;
    text-align: right;
    background: #eee;
    > div {
      height: 60px;
      margin-top: 16px;
      padding-right: 32px;
      line-height: 60px;
      background: #fff;
      .confirm-btn {
        color: #fff;
        background: #18a8c7;
        border: none;
      }
    }
  }
}
</style>
